

export const resetCreateNewWorkerReducer = (state) => {
    state.createNewWorker.status = "idle";
    state.createNewWorker.errorMessage = "";
  }